import { useRef } from "react";
import { parseTL } from "../AmountInput";

// fatura satırlarında klavye gezintisi: Enter → sonraki alan / son satırda yeni satır; son alandan çıkınca dolu satıra otomatik yeni satır
export function useLineNav(form, addLine) {
  const formRef = useRef(null);
  const lineFieldsRef = useRef(null);
  const focusNext = (from) => {
    const root = formRef.current;
    if (!root) return false;
    const els = [...root.querySelectorAll("input:not([type=hidden]):not([disabled]), select:not([disabled]), textarea:not([disabled]), button[type=submit]")].filter((el) => el.tabIndex >= 0);
    const next = els[els.indexOf(from) + 1];
    if (next) { next.focus(); return true; }
    return false;
  };
  const onLineKeyDown = (e, i, isLast) => {
    if (e.key !== "Enter" || e.ctrlKey || e.metaKey) return;
    e.preventDefault();
    if (isLast && i === form.lines.length - 1) {
      addLine();
      setTimeout(() => lineFieldsRef.current?.querySelector(`[data-line="${form.lines.length}"] input, [data-line="${form.lines.length}"] select`)?.focus(), 30);
      return;
    }
    focusNext(e.target);
  };
  const onLastFieldBlur = (i) => {
    if (i !== form.lines.length - 1) return;
    setTimeout(() => {
      const active = document.activeElement;
      const row = lineFieldsRef.current?.querySelector(`[data-line="${i}"]`);
      if (!row || row.contains(active) || !formRef.current?.contains(active) || active?.type === "submit" || active?.dataset?.noauto) return;
      const l = form.lines[i];
      if (l.project_id && parseTL(l.quantity) && parseTL(l.unit_price)) addLine();
    }, 0);
  };
  return { formRef, lineFieldsRef, focusNext, onLineKeyDown, onLastFieldBlur };
}
